import { ScoredCreditCardProduct } from '@mediaingenuity/totallymoney.types'

function getBalanceTransferOfferDurationMonths(
    creditCard: ScoredCreditCardProduct
) {
    return (
        creditCard.balanceTransferOfferDurationMonths ??
        creditCard.offerDetail.durationOfBalanceRateMonths
    )
}

export default getBalanceTransferOfferDurationMonths
